import gql from 'graphql-tag';

export const UPDATE_CURRENT_STAGE = gql`
  mutation UpdateCurrentStage($input: UpdateVOCurrentStageInput!) {
    updateVOCurrentStage(input: $input) {
      error
      success
    }
  }
`;
